import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
  headerWrapper: {
    margin: '10px 40px 14px',
    display: 'flex',
    justifyContent: 'space-between'
  },
  title: {
    color: '#335977',
    fontWeight: 'bold',
    fontSize: '38px',
  },
  cardWrapper: {
    margin: '24px 40px',
    padding: '20px',
    zIndex: 0,
    position: 'relative'
  },
  staticMargin: {
    marginRight: '10px',
    color: '#F37320'
  },
  SubheaderWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  dateInput: {
    position: 'relative',
  },
  root: {
    position: 'absolute',
    background: '#FFFFFF',
    boxShadow: '0px 0px 6px #00000029',
    borderRadius: '8px',
    top: '20px',
    display: 'flex',
    flexDirection: 'column',
    zIndex: 1
  },
  calendarWrapper: {
    display: 'flex',

    '& .MuiPickersDay-current': {
      color: 'rgba(0, 0, 0, 0.87)'
    }
  },
  buttonGroup: {
    borderTop: '1px solid #EEEEEE',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px'
  },
  button: {
    width: '20%',
    height: '30px',
    margin: 0,
    alignItems: 'center',
    padding: 0
  },
  table: {
    textAlign: 'center',
    maxHeight: 480,
    marginBottom: '20px'
  },
  tableHeader: {
    border: 'none',
    backgroundColor: '#335977',
    fontSize: '14px',
    letterSpacing: '0.07px',
    fontFamily: 'Roboto, sans-serif',
    color: '#FFE784',
    paddingRight: '0px'
  },
  sortIcon: {
    color: '#FFFFFF',
    marginLeft: '2px'
  },
  paper: {
    maxHeight: '200px',
    overflowY: 'auto',
    minWidth: '250px',
    position: 'absolute',

    '&::-webkit-scrollbar': {
      width: '5px'
    },

    '&::-webkit-scrollbar-thumb': {
      borderRadius: '3px',
      backgroundColor: '#c3c3c3',
      width: '5px'
    }
  },
  accountWrapper: {
    position: 'relative'
  },
  isBold: {
    fontWeight: 'bold',
    color: '#FFFFFF',
    fontSize:'16px',
  },
  tableCell: {
    position: 'sticky',
    background: '#B0E0E6',
    top: '55px'
  },
  infoIcon: {
    fontSize: '14px',
    cursor: 'pointer'
  },
  popper: {
    position: 'absolute',
    boxShadow: '5px 5px 3px #00000006',
    width: '200px',
    padding: '10px',
    fontSize: '14px'
  },
  dateInput: {
    position: 'relative'
  },
  selectWrapper: {
    display: "flex",
    flexWrap: "wrap",
    gap: 4,
    overflowY: "auto",   
  },
  downtimeCalendarWrapper: {
    width: 500,
    display: "flex",
    flexDirection: "column",
    margin: "0 40px",
    height: 500
  },
  sortContainer: {
    position: 'relative',
    width: 16,
    height: 20,
    marginLeft: 4
  },
  sortUp: {
    position: 'absolute',
    top: -3,
    cursor: 'pointer',
    right: 2
  },
  sortDown: {
    position: 'absolute',
    bottom: -5,
    cursor: 'pointer',
    right: 2
  },
  inactive: {
    color: '#9e9e9e'
  },
  active: {
    color: '#F37320'
  }

}))


export default useStyles